import Axios from 'axios';
import React, { useMemo, useState } from 'react'
import { Toast } from "../../common/message";
import { EmailCheck, NameCheck, PasswordCheck } from "../../common/regCheck";
import { useNavigate } from 'react-router-dom'
import dayjs from 'dayjs';
import NotData from '../../components/NotData';
import { elapsedTime } from '../../common/howDate';
import packageVersion from "../../../package.json";

const User = () => {

  // 숫자 천자리 콤마
  function NumberConvert(num) {
    var num_parts = num.toString().split(".");
    num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return num_parts.join(".");
  }

  // 시간 불러오는 부분
  let toDate = new dayjs().format('YYYY-MM-DD');
  let toTime = new dayjs().format('YYYY-MM-DD HH:mm:ss')

  const minusDate = (number)=>{
    const now = new dayjs().subtract(number, 'days');
    return now.format('YYYY-MM-DD');
  }

  const plusDate = (number)=>{
    const now = new dayjs().add(number, 'days');
    return now.format('YYYY-MM-DD');
  }

  const toDay = {
    date: toDate,
    time: toTime,
    minusDate,
    plusDate
  }
  
  const navigate = useNavigate();

  const [userInfo, setUserInfo] = useState([]);

  const [userIno, setUserIno] = useState(0);
  const [userID, setUserID] = useState('');

  const [userPassword, setUserPassword] = useState('');
  const [userPasswordCheck, setUserPasswordCheck] = useState('');

  const [nickname, setNickname] = useState('');
  const [email, setEmail] = useState('');

  // 사용자 비밀번호 변경
  const passwordChenge = async (e)=>{
    e.preventDefault();

    if(!userPassword) return Toast.fire({ icon: "warning", text: '비밀번호를 입력해 주세요'});
    if(!userPasswordCheck) return Toast.fire({ icon: "warning", text: '비밀번호 확인을 입력해 주세요'});
    if(userPassword !== userPasswordCheck) return Toast.fire({ icon: "warning", text: '비밀번호가 서로 다릅니다'});
    if(!PasswordCheck(userPassword)) return Toast.fire({ icon: "warning", text: '비밀번호는 영문, 숫자만 포함 6~20자리를 입력해 주세요'});
    
  if(!window.confirm(`비밀번호를 변경하시겠습니까?`)) return;

  await Axios.put(`/api/user/userpassword`, {
    UserIno: userIno, UserPassword: userPassword
  })
  .then((res)=>{
    setUserPassword('');
    setUserPasswordCheck('');
    Toast.fire({ icon: "success", text: '비밀번호를 변경했습니다'});
  })
}

  // 사용자 정보 불러오기
  const dataLoade = async () => {
    await Axios.get(`/api/user/mypage`, {
      params: { userID: window.sessionStorage.getItem('basicID') }
    })
    .then((res) => {
      if (res.data.length) {
        setUserInfo(res.data[0]);

        setUserIno(res.data[0].no);
        setUserID(res.data[0].id);
      } else {
        setUserInfo([]);
      }
    });
  };
  
  // 사용자 계정 삭제하기
  const userDelete = async ()=>{

    let message = window.prompt('확인을 위해 로그인된 계정의 아이디를 입력해 주세요');
    if(message === null){
      return;
    } else if(message === ''){
      return alert('아이디를 입력하지 않아 계정 삭제를 취소합니다');
    } else if(message !== userID){
      return alert('아이디가 다릅니다.');
    } 
    
    if(!window.confirm('사용자의 계정을 삭제하시겠습니까?')) return;

    await Axios.put(`/api/user/userdelete`, {
      UserIno: userIno, Date: toDay.time
    })
    .then((res)=>{
      sessionDelete();
      Toast.fire({ icon: "success", text: '계정을 삭제했습니다'});
      navigate('/login');
    })
  }

  // 세션 삭제
  const sessionDelete = async ()=>{
    await Axios.get(`/api/deletesession`)
    .then(()=>{
      window.sessionStorage.clear();
      navigate('/login');
    });
  }

  // 이메일 변경시 바로 적용되도록

  // 닉네임 변경 함수
  const nickNameChanhe = async (e)=>{
    e.preventDefault();

    if(!nickname) return Toast.fire({ icon: "warning", text: '닉네임을 입력해 주세요'});
    if(nickname.length < 2) return Toast.fire({ icon: "warning", text: '닉네임은 2글자 이상 입력해 주세요'});
    if(nickname.length > 10) return Toast.fire({ icon: "warning", text: '닉네임은 10글자 이상 입력할 수 없습니다'});
    if(!NameCheck(nickname)) return Toast.fire({ icon: "warning", text: '닉네임은 한글 실명으로만 입력해 주세요'});

    if(!window.confirm(`닉네임을 ${nickname}로 수정하시겠습니까?`)) return;

    await Axios.put(`/api/user/nicknamechange`, {
      UserIno: userIno, NickName: nickname
    })
    .then((res)=>{

      sessionDelete();

      Toast.fire({ icon: "success", text: '닉네임을 수정했습니다'});

    })
  }

  // 이메일 변경 함수
  const emailChange = async (e)=>{
    e.preventDefault();

    if(!email) return Toast.fire({ icon: "warning", text: '이메일을 입력해 주세요'});
    if(email.length > 30) return Toast.fire({ icon: "warning", text: '이메일은 30글자 이상 입력할 수 없습니다'});
    if(!EmailCheck(email)) return Toast.fire({ icon: "warning", text: '이메일 형식을 다시 확인해 주세요'});

    if(!window.confirm(`이메일을 ${email}로 하시겠습니까?`)) return;

    await Axios.put(`/api/user/emailchange`, {
      UserIno: userIno, Email: email
    })
    .then((res)=>{

      sessionDelete();

      Toast.fire({ icon: "success", text: '이메일을 수정했습니다'});

    })
  }

  // 포인트 및 기여도 테이블 관련 부분
  const columns = ['ID', '상태', '포인트', '기여도', '배수', '위치', '로그', '시간'];

  const [selectedRow, setSelectRow] = useState(-1);
  const [point_exp_Table, setPoint_Exp_Table] = useState([]); // 로그
  const [point_value, setPoint_value] = useState(0); // 포인트 데이터
  const [exp_value, setExp_value] = useState(0); // 기여도 데이터

  // 사용자 정보 불러오기
  const point_exp_log = async () => {
    await Axios.get(`/api/user/pointexplog`, {
      params: { userID: window.sessionStorage.getItem('basicID'), Date: toDay.date }
    })
    .then((res) => {
      if (res.data.length) {
        setPoint_Exp_Table(res.data);
      } else {
        setPoint_Exp_Table([]);
      }
    });
  };

  // 사용자 포인트 불러오기
  const point_data = async () => {
    await Axios.get(`/api/user/point`, {
      params: { userID: window.sessionStorage.getItem('basicID') }
    })
    .then((res) => {
      if (res.data.length) {
        setPoint_value(res.data[0].POINT);
      } else {
        setPoint_value([]);
      }
    });
  };

  // 사용자 기여도 불러오기
  const exp_data = async () => {
    await Axios.get(`/api/user/exp`, {
      params: { userID: window.sessionStorage.getItem('basicID') }
    })
    .then((res) => {
      if (res.data.length) {
        setExp_value(res.data[0].EXP);
      } else {
        setExp_value([]);
      }
    });
  };

  const [pageCount, setPageCount] = useState(0);
  
  // 세션체크 부분 세션 페이징 카운터
  const session = async ()=>{
    await Axios.get(`/api/usersession`)
    .then((res)=>{
      if(res.data.value)
      {
        setPageCount(res.data.count ?? 0)
      }
    })
  }

  // 해당 기능은 최 하단에 배치해야 함
  useMemo(()=>{
    document.title = '내 정보';

    dataLoade();

    point_exp_log();

    point_data();
    exp_data();

    session();
  }, [])

  return (
    <div className="flex flex-col items-center p-3 text-sm gap-3">

      {/* 사용자 프로필 */}
      <div className='flex flex-col w-full md:max-w-screen-md lg:max-w-screen-lg gap-3 p-3 bg-[#3E3E3E] rounded-md'>
        {/* 프로필 부분 */}
        <div className='flex flex-col md:grid md:grid-cols-2 border-[1px] border-gray-500 items-center justify-center gap-5 bg-[#2E2E2E] p-3 rounded-md'>
          <div className='flex justify-center md:ml-10 items-center border-yellow-500/90 shadow-inner whitespace-normal shadow-yellow-400 border-[3px] rounded-[50%] w-32 h-32'>
            <p style={{fontFamily: 'Gugi'}} className='text-gray-200 hover:scale-125 text-xl duration-150 rounded-[50%] whitespace-normal p-5 shadow-yellow-500'>
              {`${userInfo.id ?? '-'}`}
            </p>
          </div>
          <div className='w-full flex flex-col gap-3'>
            <div>
              <p className='text-gray-400 mb-1'>닉네임</p>
              <p style={{fontFamily: 'Gugi'}} className='bg-[#3E3E3E] tracking-wider p-3 rounded-md text-base'>{userInfo.name ?? '-'}</p>
            </div>
            <div>
              <p className='text-gray-400 mb-1'>이메일</p>
              <p style={{fontFamily: 'Gugi'}} className='bg-[#3E3E3E] tracking-wider p-3 rounded-md text-base whitespace-normal'>{!userInfo.email ? '-' : userInfo.email }</p>
            </div>
          </div>
        </div>

        {/* 사용자 정보 그리드들 */}
        <div className='grid grid-cols-2 md:grid-cols-3 w-full gap-3'>
          <div className='flex flex-col md:flex-row md:justify-between items-center gap-1 md:gap-3 bg-[#2E2E2E] border-[1px] border-gray-500 p-3 rounded-md'>
            <p className='text-gray-400'>페이지 카운터</p>
            <p style={{fontFamily: 'Gugi'}}className='bg-green-600 py-1 tracking-wider px-3 rounded-sm'>{pageCount ?? 0}</p>
            {/* 페이징 카운터란, 세션이 유지된 상태로 몇 번이나 페이징을 했는지의 숫자입니다. 큰 의미는 없으나 그만큼 많은 활동을 했다는 뜻입니다. */}
          </div>
          <div className='flex flex-col md:flex-row md:justify-between items-center gap-1 md:gap-3 bg-[#2E2E2E] border-[1px] border-gray-500 p-3 rounded-md'>
            <p className='text-gray-400'>이용 권한</p>
            <p style={{fontFamily: 'Gugi'}}className='bg-green-600 py-1 tracking-wider px-3 rounded-sm'>{userInfo.state ? '승인' : '차단'}</p>
          </div>
          <div className='flex flex-col md:flex-row md:justify-between items-center gap-1 md:gap-3 bg-[#2E2E2E] border-[1px] border-gray-500 p-3 rounded-md'>
            <p className='text-gray-400'>계정 상태</p>
            <p style={{fontFamily: 'Gugi'}}className='bg-green-600 py-1 tracking-wider px-3 rounded-sm'>{!userInfo.delite ? '정상' : '삭제'}</p>
          </div>
          <div className='flex flex-col md:flex-row md:justify-between items-center gap-1 md:gap-3 bg-[#2E2E2E] border-[1px] border-gray-500 p-3 rounded-md'>
            <p className='text-gray-400'>담당매장</p>
            <p style={{fontFamily: 'Gugi'}}className='bg-[#3E3E3E] py-1 tracking-wider px-3 rounded-sm'>{userInfo.store ?? '-'}</p>
          </div>
          <div className='flex flex-col md:flex-row md:justify-between items-center gap-1 md:gap-3 bg-[#2E2E2E] border-[1px] border-gray-500 p-3 rounded-md'>
            <p className='text-gray-400'>직책</p>
            <p style={{fontFamily: 'Gugi'}}className='bg-[#3E3E3E] py-1 tracking-wider px-3 rounded-sm'>{userInfo.position ?? '-'}</p>
          </div>
          <div className='flex flex-col md:flex-row md:justify-between items-center gap-1 md:gap-3 bg-[#2E2E2E] border-[1px] border-gray-500 p-3 rounded-md'>
            <p className='text-gray-400'>이용시간</p>
            <p style={{fontFamily: 'Gugi'}}className='bg-[#3E3E3E] py-1 tracking-wider px-3 rounded-sm'>{`${userInfo.play_time ? parseInt(userInfo.play_time / 60 / 60 ?? 0) : 0} 시간`}</p>
          </div>
          <div className='flex flex-col md:flex-row md:justify-between items-center gap-1 md:gap-3 bg-[#2E2E2E] border-[1px] border-gray-500 p-3 rounded-md'>
            <p className='text-gray-400'>포인트</p>
            <p style={{fontFamily: 'Gugi'}}className={`${point_value < 0 && 'bg-red-500 animate-pulse'} bg-[#3E3E3E] py-1 tracking-wider px-3 rounded-sm`}>
              {NumberConvert(point_value ?? 0)}
            </p>
          </div>          
          <div className='flex flex-col md:flex-row md:justify-between items-center gap-1 md:gap-3 bg-[#2E2E2E] border-[1px] border-gray-500 p-3 rounded-md'>
            <p className='text-gray-400'>기여도</p>
            <p style={{fontFamily: 'Gugi'}}className={`${exp_value < 0 && 'bg-red-500 animate-pulse'} bg-[#3E3E3E] py-1 tracking-wider px-3 rounded-sm`}>
              {NumberConvert(exp_value ?? 0)}
            </p>
          </div>
          <div className='flex flex-col md:flex-row md:justify-between items-center gap-1 md:gap-3 bg-[#2E2E2E] border-[1px] border-gray-500 p-3 rounded-md'>
            <p className='text-gray-400'>가입날짜</p>
            <p style={{fontFamily: 'Gugi'}} className='bg-[#3E3E3E] py-1 tracking-wider px-3 rounded-sm'>{`${userInfo.date ?? '-'}`.substr(0, 10)}</p>
          </div>
        </div>
      </div>

      {/* 사용자 포인트 및 기여도 부분 */}
      <div className='flex flex-col w-full max-w-screen-md md:max-w-screen-md lg:max-w-screen-lg gap-3 p-3 bg-[#3E3E3E] rounded-md'>

        <div className='bg-[#2E2E2E] p-3 rounded-md font-semibold flex justify-between'>
          <p>당일 포인트 및 기여도 지급 기록</p>
          <p>총 {point_exp_Table.length ?? 0} 건</p>
        </div>

        <div className='grid grid-cols-1 gap-3'>

          <div className='relative h-[50vh] md:h-[30vh] rounded-lg border-[3px] bg-[#2E2E2E] border-[#2E2E2E] w-full overflow-y-auto'>
            <table id='testTable' className='w-full'>
              <thead className='bg-[#1E1E1E]/90 text-center whitespace-nowrap sticky top-0 z-10'>
                <tr className="border-b-[1px] border-[#2E2E2E]">
                  {columns.map((column, idx) => (
                    <th className='p-3 first:border-r-[1px] border-b-[1px] border-[#3E3E3E]' key={idx}>{column}</th>
                  ))}
                </tr>
              </thead>
              <tbody className='text-center'>
                  {/* <tr key={idx} className={`duration-150 decoration-yellow-600 whitespace-nowrap active:scale-[0.98] active:opacity-80                      
                    ${`${item.point}`.includes('-') && 'bg-red-600/60'}
                    ${selectedRow === idx && 'bg-[#1E1E1E] font-bold underline decoration-4'}
                    `}
                    onClick={(e)=>{
                    setSelectRow(idx);
                    }}> */}
                  {
                  // ${`${item.point}`.includes('-') ? 'bg-red-600/60' : selectedRow === idx && 'bg-[#1E1E1E] font-bold underline decoration-4'}
                  point_exp_Table.length ?
                  point_exp_Table.map((item, idx) => (
                    // ${`${item.point}`.includes('-') && 'bg-red-600/60'}
                    <tr key={idx} className={`duration-150 decoration-yellow-600 whitespace-nowrap active:scale-[0.98] active:opacity-80                      
                      ${item.add && 'bg-blue-600/50'}
                      ${selectedRow === idx && 'bg-[#1E1E1E] font-bold underline decoration-[3px]'}
                      `}
                      onClick={(e)=>{
                      setSelectRow(idx);
                    }}>
                      <td className='p-2.5 border-r-[1px] border-[#4E4E4E] text-stone-300'>{item.no}</td>
                      <td className='p-2.5 border-x-[1px] border-[#4E4E4E] text-stone-300'>{item.state}</td>
                      <td className={`p-2.5 text-stone-300 ${`${item.point}`.includes('-') && 'bg-red-600/60'}`}>
                        {NumberConvert(item.point)} P
                      </td>
                      <td className={`p-2.5 text-stone-300 ${`${item.exp}`.includes('-') && 'bg-red-600/60'}`}>
                        {NumberConvert(item.exp)} E
                      </td>
                      <td className='p-2.5 text-stone-300'><p>x {item.p_bonus}</p></td>
                      <td className='p-2.5 text-stone-300'>{item.location}</td>
                      <td className='p-2.5 text-stone-300'>{item.log}</td>
                      <td className={`p-2.5 text-stone-300 ${elapsedTime(item.date) === '방금 전' && 'animate-pulse'}`}>
                        {elapsedTime(item.date)}
                      </td>                      
                    </tr>
                  ))
                  :
                  <tr className='relative'>
                    <td className='absolute w-full md:top-[10vh] top-[17vh] h-full'>
                      <NotData />
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>

        </div>
      </div>

      {/* 네임 및 이메일 변경 */}
      <div className='grid grid-cols-1 md:grid-cols-2 gap-3 max-w-screen-md md:max-w-screen-md lg:max-w-screen-lg w-full'>
        <form autoComplete='off' className='flex flex-col w-full max-w-screen-md gap-3 p-3 bg-[#3E3E3E] rounded-md'>
          <div className='flex flex-col md:py-3'>
            <p className='font-semibold'>닉네임 변경</p>
            <input
              className="bg-[#2E2E2E] mt-2 focus:border-[#2E2E2E] focus:scale-105 hover:border-gray-500 duration-150 h-12 w-full p-2 rounded-md outline-none border-[1px] border-gray-400"
              type="text"
              value={nickname}
              onChange={(e)=>setNickname(e.target.value)}
              placeholder="닉네임">
            </input>
            <div>
              <button className="bg-[#2E2E2E] mt-3 h-12 w-[100%] active:bg-[#1E1E1E] rounded-md text-center duration-100 hover:scale-[0.99] hover:opacity-80"
              onClick={nickNameChanhe}>
                닉네임 변경
              </button>
            </div>
          </div>        
        </form>

        <form autoComplete='off' className='flex flex-col w-full max-w-screen-md md:max-w-screen-md lg:max-w-screen-lg gap-3 p-3 bg-[#3E3E3E] rounded-md'>
          <div className='flex flex-col md:py-3'>
            <p className='font-semibold'>이메일 변경</p>
            <input
              className="bg-[#2E2E2E] mt-2 focus:border-[#2E2E2E] focus:scale-105 hover:border-gray-500 duration-150 h-12 w-full p-2 rounded-md outline-none border-[1px] border-gray-400"
              type="email"
              value={email}
              onChange={(e)=>setEmail(e.target.value)}
              placeholder="이메일">
            </input>
            <div>
              <button className="bg-[#2E2E2E] mt-3 h-12 w-[100%] active:bg-[#1E1E1E] rounded-md text-center duration-100 hover:scale-[0.99] hover:opacity-80"
              onClick={emailChange}>
                이메일 변경
              </button>
            </div>
          </div>        
        </form>
      </div>

      {/* 알림바 */}
      <div className='p-3 max-w-screen-md md:max-w-screen-md lg:max-w-screen-lg w-full bg-[#1E1E1E]/80 rounded-md'>
        <p>📢 닉네임 및 이메일 변경시 로그아웃되며, 로그인하시면 정상적으로 반영됩니다</p>
      </div>

      {/* 비밀번호 변경 */}
      <form autoComplete='off' className='flex flex-col w-full max-w-screen-md md:max-w-screen-md lg:max-w-screen-lg gap-3 p-3 bg-[#3E3E3E] rounded-md'>
        <div className='grid grid-cols-1 md:grid-cols-2 gap-3 md:py-3'>
          <div>
            <p className='font-semibold'>비밀번호</p>
            <input
              className="bg-[#2E2E2E] mt-2 focus:border-[#2E2E2E] focus:scale-105 hover:border-gray-500 duration-150 h-12 w-full p-2 rounded-md outline-none border-[1px] border-gray-400"
              type="password"
              value={userPassword}
              onChange={(e)=>setUserPassword(e.target.value)}
              placeholder="비밀번호">
            </input>
          </div>
          <div>
            <p className='font-semibold'>비밀번호 확인</p>
            <input
              className="bg-[#2E2E2E] mt-2 focus:border-[#2E2E2E] focus:scale-105 hover:border-gray-500 duration-150 h-12 w-full p-2 rounded-md outline-none border-[1px] border-gray-400"
              type="password"
              value={userPasswordCheck}
              onChange={(e)=>setUserPasswordCheck(e.target.value)}
              placeholder="비밀번호 확인">
            </input>
          </div>
        </div>
        <div>
          <button className="bg-[#2E2E2E] h-12 w-[100%] active:bg-[#1E1E1E] rounded-md text-center duration-100 hover:scale-[0.99] hover:opacity-80"
          onClick={passwordChenge}>
            비밀번호 변경
          </button>
        </div>
      </form>
      
      {/* 계정 삭제 */}
      <div className='flex flex-col w-full max-w-screen-md lg:max-w-screen-lg md:max-w-screen-md gap-3 p-3 bg-[#3E3E3E] rounded-md'>
        <div className='flex flex-col gap-3 md:py-3'>
          <p className='font-semibold'>사용자의 계정을 삭제합니다</p>
          <button className="bg-[#2E2E2E] h-12 w-[100%] active:bg-[#1E1E1E] rounded-md text-center duration-100 hover:scale-[0.99] hover:opacity-80"
          onClick={userDelete}>
            계정 삭제하기
          </button>
        </div>
        <div className='bg-[#2E2E2E] p-3 rounded-md text-gray-300'>
          <p>사용자는 언제는지 계정을 삭제할 수 있습니다, 새로운 계정도 언제든지 생성할 수 있으며 새로운 계정으로 로그인 시도시, 관리자의 이용 권한 허가가 필요합니다. <span className='text-red-300'>삭제된 아이디로는 회원가입이 불가능합니다. </span>계정이 삭제되어도 지금까지 처리된 데이터들은 삭제되지 않습니다.</p>
        </div>
      </div>

      {/* 버전 표기 */}
      <div className="text-right text-[#4E4E4E] font-bold text-xs">
        <p>{`v${packageVersion.version}`}</p>
      </div>

    </div>
  )
}

export default User